import { DeviceEventEmitter, NativeModules, Platform } from 'react-native';

export type SpeechResultEvent = {
  value?: string;
};

export type SpeechErrorEvent = {
  code?: number;
  message?: string;
};

export type SpeechEventName = 'onResult' | 'onPartialResult' | 'onEnd' | 'onError';

interface AndroidSpeechRecognizerNativeModule {
  isAvailable: () => Promise<boolean>;
  start: (locale: string) => Promise<boolean>;
  stop: () => Promise<void>;
  destroy: () => Promise<void>;
}

const nativeModule =
  Platform.OS === 'android'
    ? (NativeModules.AndroidSpeechRecognizer as AndroidSpeechRecognizerNativeModule | undefined)
    : undefined;

const nativeEmitter = Platform.OS === 'android' ? DeviceEventEmitter : null;

const isNativeReady = () => Platform.OS === 'android' && !!nativeModule;

function addListener(
  eventName: 'onResult' | 'onPartialResult',
  callback: (event: SpeechResultEvent | undefined) => void
): { remove: () => void };
function addListener(
  eventName: 'onError',
  callback: (event: SpeechErrorEvent | undefined) => void
): { remove: () => void };
function addListener(
  eventName: 'onEnd',
  callback: (event: undefined) => void
): { remove: () => void };
function addListener(
  eventName: SpeechEventName,
  callback: (event: any) => void
): { remove: () => void } {
  if (!nativeEmitter) {
    return { remove: () => {} };
  }

  return nativeEmitter.addListener(eventName, callback);
}

const AndroidSpeechRecognizer = {
  isNativeReady,
  isAvailable: async (): Promise<boolean> => {
    if (!isNativeReady()) {
      return false;
    }

    return nativeModule!.isAvailable();
  },
  start: async (locale: string): Promise<boolean> => {
    if (!isNativeReady()) {
      return false;
    }

    return nativeModule!.start(locale);
  },
  stop: async (): Promise<void> => {
    if (!isNativeReady()) {
      return;
    }

    await nativeModule!.stop();
  },
  destroy: async (): Promise<void> => {
    if (!isNativeReady()) {
      return;
    }

    await nativeModule!.destroy();
  },
  addListener,
};

export default AndroidSpeechRecognizer;
